export function fechaOf(log) {
  return String(log?.fecha || '').trim().slice(0, 10);
}

export function sortLogsNewestFirst(logs) {
  return [...(logs || [])].sort((a, b) => {
    const cmp = fechaOf(b).localeCompare(fechaOf(a));
    if (cmp) return cmp;
    return Number(b.id || 0) - Number(a.id || 0);
  });
}

export function latestLogPerUser(logs) {
  const seen = new Set();
  const latest = [];
  const historyByUser = new Map();
  for (const log of sortLogsNewestFirst(logs)) {
    const uid = Number(log?.user_id);
    if (!Number.isFinite(uid)) continue;
    if (!seen.has(uid)) {
      seen.add(uid);
      latest.push(log);
      historyByUser.set(uid, []);
    } else {
      historyByUser.get(uid).push(log);
    }
  }
  return { latest, historyByUser };
}
